export default {
  B2C: 'b2c',
  B2B: 'b2b',
  OUTLET: 'outlet',
  EMPLOYEE: 'employee',
  ENDLESS_AISLE: 'ea',
  AAF: 'aaf',
};
